module.exports = __webpack_public_path__ + "img/banner-transport.5911fe4b.jpeg";